import React from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Box, Text, Alert, Flex, Loader } from "rizzui";
import instanceAxios from "@/Core/Client/AxiosConfig";
import { EndPoints } from "@/Core/Client";

// Define the interface for your event data
interface EventDetails {
    id: number;
    name: string;
    description: string;
    ticketCount: number;
    soldTickets: number;
    // Add other event properties as needed
}

const EventDetailsPage: React.FC = () => {
    const { id: eventId } = useParams<{ id: string }>(); // Get id from route params

    // Use react-query to fetch the event details
    const { data: event, isLoading, isError, error } = useQuery<EventDetails, Error>(
        {
            queryKey: ["eventDetails", eventId], // Query key (important for caching and re-fetching)
            queryFn: () => instanceAxios.get<EventDetails>(EndPoints.events.details(eventId!)).then((res) => res.data), // Fetch event details
            enabled: !!eventId, // Only fetch if eventId is available
            retry: 1, // Retry once if the request fails
        }
    );

    if (isLoading) {
        return (
            <Box className="flex justify-center align-center">
                <Loader size="lg" color="primary" />
            </Box>
        );
    }

    if (isError) {
        return (
            <Alert color="danger">
                <Text>Error fetching event details: {(error as Error).message}</Text>
            </Alert>
        );
    }

    if (!event) {
        return <Text>Event not found.</Text>;
    }

    const remainingTickets = event.ticketCount - event.soldTickets;

    return (
        <Box className="p-4">
            <h1 className="mb-4">
                {event.name}
            </h1>
            <Text className="mb-4">{event.description}</Text>

            <div>
                <div>
                    <div>
                        <h1>Ticket Information</h1>
                    </div>
                    <div>
                        <Flex direction="col" gap="2">
                            <Text>Total Tickets: {event.ticketCount}</Text>
                            <Text>Sold Tickets: {event.soldTickets}</Text>
                            <Text>Remaining Tickets: {remainingTickets}</Text>
                        </Flex>
                    </div>
                </div>
            </div>

            {/* You can add more details about the event here */}
        </Box>
    );
};

export default EventDetailsPage;

